import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObjectiveLookupComponent } from './objective-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ObjectiveLookupComponent],
  exports: [ObjectiveLookupComponent]
})
export class ObjectiveLookupModule { }
